/* eslint-disable sonarjs/no-duplicate-string */
// eslint-disable-next-line import/prefer-default-export
export var DOCUMENTS_TRANSLATIONS = {
    documents: {
        front: 'Frente do documento"',
        back: 'Verso do documento',
        important: 'Importante!',
        importantPoint1: 'Todos os documentos devem <b>coincidir com o responsável pelo CNPJ.</b>',
        importantPoint2: 'Os documentos devem ser <b>claros, legíveis, vigentes e completos. (Ex: frente e verso).</b>',
        importantPoint3: 'Se o documento contiver uma chave, <b>adicione-a ao nome do arquivo.</b>',
        title: {
            one: 'Arraste o arquivo aqui, ou',
            other: 'Arraste os arquivos aquí, ou',
        },
        selectFile: {
            one: 'Fazer upload de arquivo',
            other: 'Fazer upload de arquivos',
        },
        allowedExtensions: 'Formatos permitidos:',
        maxSize: 'Tamanho máximo:',
        minResolution: 'Resolução mínima:',
        example: 'Exemplo de documento',
        removeFile: 'Excluir arquivo',
        agreed: 'Entendido',
        error: {
            title: 'Ocorreu um erro ao carregar',
            tooLarge: 'O tamanho do arquivo é maior que o permitido',
            tooSmall: 'A resolução da imagem é inferior à permitida',
            invalidType: 'Formato de arquivo inválido',
            tooManyFiles: {
                one: 'Máximo 1 archivo} ',
                other: 'Máximo {{quantity}} archivos}}',
            },
            genericError: 'Tente novamente',
            requiredFile: 'Documento obrigatório',
            summary: 'Encontramos um erro em seus documentos, verifique e carregue-os novamente.',
        },
        camera: {
            cancel: 'Cancelar',
            frontPicture: 'Enquadre e tire uma foto frontal do documento',
            backPicture: 'Enquadre e tire uma foto do verso do documento',
            picturesReady: 'As fotos do documento estão prontas, dê uma olhada nelas e confira como ficaram.',
            frontPreview: 'Frente do documento',
            backPreview: 'Verso do documento',
            requiredField: 'Campo obrigatório',
            start: 'Começar',
            ok: 'Ok',
            replaceImage: 'Substituir foto',
            continue: 'Continuar',
        },
        identification: {
            CO: {
                DEFAULT: 'Anexe o documento atual e ele deve ser enviado frente e verso.',
                Personanatural: 'Anexe o documento atual e ele deve ser enviado frente e verso.',
                Personajuridica: 'Anexe o documento atual e ele deve ser enviado frente e verso.',
            },
            AR: {
                DEFAULT: 'O documento de identidade DNI deve ser anexado na frente e no verso.',
                Personahumana: 'O documento de identidade DNI deve ser anexado na frente e no verso.',
                Personajuridica: 'O documento de identidade DNI deve ser anexado na frente e no verso.',
            },
            UY: {
                DEFAULT: 'Deve ser anexado um Bilhete de Identidade em ambos os lados (verso e verso) ou um Passaporte válido.',
                Personafisica: 'Deve ser anexado um Bilhete de Identidade em ambos os lados (verso e verso) ou um Passaporte válido.',
                Personajuridica: 'Deve ser anexado um Bilhete de Identidade em ambos os lados (verso e verso) ou um Passaporte válido.',
            },
            CR: {
                DEFAULT: 'Anexe a face frontal do ID físico ou DIMEX. O documento deve ser atual.',
                Personanatural: 'Anexe a face frontal do ID físico ou DIMEX. O documento deve ser atual.',
                Personajuridica: 'Anexe o ID físico ou DIMEX. O documento deve ser atual.',
            },
            BR: {
                DEFAULT: 'Anexe o documento atual e deve ser enviado na frente e no verso.',
                Pessoafisica: 'Documento legal com foto e número de identificação do RH e/ou CPF',
                Pessoajuridica: 'Documento legal com foto e número de identificação do RH e/ou CPF',
                Personanatural: 'Anexe o documento atual e deve ser enviado na frente e no verso.',
            },
            CL: {
                DEFAULT: 'Anexar a carteira de identidade atual e deve ser enviada na frente e no verso.',
                Personanatural: 'Anexar a carteira de identidade atual e deve ser enviada na frente e no verso.',
                Personajuridica: 'Anexar a carteira de identidade atual e deve ser enviada na frente e no verso.',
            },
            EC: {
                DEFAULT: 'O documento deve estar atualizado e a frente e o verso devem estar anexados. O nome deve coincidir com o nome do representante legal que está refletido no RUC.',
                Personanatural: 'O documento deve estar atualizado e a frente e o verso devem estar anexados. O nome deve coincidir com o nome do representante legal que está refletido no RUC.',
                Personajuridica: 'O documento deve estar atualizado e a frente e o verso devem estar anexados. O nome deve coincidir com o nome do representante legal que está refletido no RUC.',
            },
            PE: {
                DEFAULT: 'O documento deve ser legível e a frente deve ser anexada. O nome deve coincidir com o nome do representante legal que está refletido no RUC.',
                Personanatural: 'O documento deve ser legível e a frente deve ser anexada. O nome deve coincidir com o nome do representante legal que está refletido no RUC.',
                Personajuridica: 'O documento deve ser legível e a frente deve ser anexada. O nome deve coincidir com o nome do representante legal que está refletido no RUC.',
            },
            MX: {
                DEFAULT: 'O documento deve estar atualizado e a frente e o verso devem ser anexados.',
                Personafisica: 'O documento deve estar atualizado e a frente e o verso devem ser anexados.',
                Personamoral: 'O documento deve estar atualizado e a frente e o verso devem ser anexados. O nome deve corresponder ao nome do representante legal refletido no Contrato Social como administrador único.',
            },
        },
        bankCertification: {
            CO: {
                DEFAULT: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
                Personanatural: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
                Personajuridica: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
            },
            AR: {
                DEFAULT: 'Deve ser anexado um documento bancário no qual possa ser exibido o nome do titular, número da CBU, número da conta, número do CUIT ou Cuil e nome do banco.',
                Personahumana: 'Deve ser anexado um documento bancário no qual possa ser exibido o nome do titular, número da CBU, número da conta, número do CUIT ou Cuil e nome do banco.',
                Personajuridica: 'Deve ser anexado um documento bancário no qual possa ser exibido o nome do titular, número da CBU, número da conta, número do CUIT ou Cuil e nome do banco.',
            },
            UY: {
                DEFAULT: 'Deve ser anexado um certificado bancário onde seja possível identificar o número do documento do mesmo, o nome da entidade bancária e o número da conta.',
                Personafisica: 'Deve ser anexado um certificado bancário onde seja possível identificar o número do documento do mesmo, o nome da entidade bancária e o número da conta.',
                Personajuridica: 'Deve ser anexado um certificado bancário onde seja possível identificar o número do documento do mesmo, o nome da entidade bancária e o número da conta.',
            },
            CR: {
                DEFAULT: 'O documento deve conter o nome do titular, nome do banco e número da conta. O produto deve estar ativo.',
                Personanatural: 'O documento deve conter o nome do titular, nome do banco e número da conta. O produto deve estar ativo.',
                Personajuridica: 'O documento deve conter o nome do titular, nome do banco e número da conta. O produto deve estar ativo.',
            },
            BR: {
                DEFAULT: 'O documento deve conter o nome do titular, nome do banco e número da conta. O produto deve estar ativo.',
                Personanatural: 'O documento deve conter o nome do titular, nome do banco e número da conta. O produto deve estar ativo.',
                Personajuridica: 'O documento deve conter o nome do titular, nome do banco e número da conta. O produto deve estar ativo.',
                Pessoajuridica: 'O documento deve conter o nome do titular, nome do banco e número da conta. O produto deve estar ativo.',
            },
            CL: {
                DEFAULT: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
                Personanatural: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
                Personajuridica: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
            },
            EC: {
                DEFAULT: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
                Personanatural: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
                Personajuridica: 'Emitido pelo banco, deve conter o número da conta e o nome do titular. O produto deve estar ativo.',
            },
            PE: {
                DEFAULT: 'Emitido pelo banco, deve conter o nome do titular, o Código de Conta Interbancária (CCI) e o número da conta. O produto deve estar ativo.',
                Personanatural: 'Emitido pelo banco, deve conter o nome do titular, o Código de Conta Interbancária (CCI) e o número da conta. O produto deve estar ativo.',
                Personajuridica: 'Emitido pelo banco, deve conter o nome do titular, o Código de Conta Interbancária (CCI) e o número da conta. O produto deve estar ativo.',
            },
            MX: {
                DEFAULT: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Clabe Interbancaria, y numero de cuenta. El producto debe estar activo.',
                Personafisica: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Clabe Interbancaria, y numero de cuenta. El producto debe estar activo.',
                Personamoral: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Clabe Interbancaria, y numero de cuenta. El producto debe estar activo.',
            },
        },
        rut: {
            CO: {
                DEFAULT: 'Deve conter o número do NIT, razão social, nome do representante legal, endereço fiscal e validade de 2019-2020 ou a mais recente até o ano vigente.',
                Personanatural: 'Deve conter o número do NIT, razão social, nome do representante legal, endereço fiscal e validade de 2019-2020 ou a mais recente até o ano vigente.',
                Personajuridica: 'Deve conter o número do NIT, razão social, nome do representante legal, endereço fiscal e validade de 2019-2020 ou a mais recente até o ano vigente. Deve ser preenchido para verificar o nome do representante legal.',
            },
            AR: {
                DEFAULT: 'A certidão fiscal AFIP ou ANSES atual deve ser anexada. Deve conter o número CUIT/CUIL e o nome da empresa.',
                Personahumana: 'A certidão fiscal AFIP ou ANSES atual deve ser anexada. Deve conter o número CUIT/CUIL e o nome da empresa.',
                Personajuridica: 'A certidão fiscal AFIP ou ANSES atual deve ser anexada. Deve conter o número CUIT/CUIL e o nome da empresa.',
            },
            UY: {
                DEFAULT: 'Deve ser anexado o certificado DGI emitido pela atual Direção Geral de Impostos. Deve conter o número RUT, endereço fiscal e nome da empresa.',
                Personafisica: 'Deve ser anexado o certificado DGI emitido pela atual Direção Geral de Impostos. Deve conter o número RUT, endereço fiscal e nome da empresa.',
                Personajuridica: 'Deve ser anexado o certificado DGI emitido pela atual Direção Geral de Impostos. Deve conter o número RUT, endereço fiscal, razão social e nome do representante legal.',
            },
            CR: {
                DEFAULT: 'Anexe o documento do nome da empresa perante a administração tributária da Costa Rica. Deve ser registrado e válido.',
                Personanatural: 'Anexe o documento do nome da empresa perante a administração tributária da Costa Rica. Deve ser registrado e válido.',
                Personajuridica: 'Anexe o documento do nome da empresa perante a administração tributária da Costa Rica. Deve ser registrado e válido.',
            },
            BR: {
                DEFAULT: 'A empresa deve estar no ramo alimentício e ativo na receita federal',
                Persoanatural: 'A empresa deve estar no ramo alimentício e ativo na receita federal',
                Pessoajuridica: 'A empresa deve estar no ramo alimentício e ativo na receita federal',
            },
            CL: {
                DEFAULT: 'O documento emitido pela Receita Federal deve ser anexado. Deve conter o número e-RUC, o nome do representante legal e o nome da empresa.',
                Personanatural: 'O documento emitido pela Receita Federal deve ser anexado. Deve conter o número e-RUC, o nome do representante legal e o nome da empresa.',
                Personajuridica: 'O documento emitido pela Receita Federal deve ser anexado. Deve conter o número e-RUC, nome do representante legal, nome da empresa e tipo de empresa.',
            },
            EC: {
                DEFAULT: 'Deve conter o número RUC, nome do representante legal e nome da empresa.',
                Personanatural: 'Deve conter o número RUC, nome do representante legal e nome da empresa.',
                Personajuridica: 'Deve conter o número RUC, nome do representante legal, nome da empresa e tipo de empresa.',
            },
            PE: {
                DEFAULT: 'O documento deve estar ativo e deve conter o número RUC, nome do representante legal e nome da empresa.',
                Personanatural: 'O documento deve estar ativo e deve conter o número RUC, nome do representante legal e nome da empresa.',
                Personajuridica: 'O documento deve estar ativo e deve conter o número RUC, nome do representante legal e nome da empresa e tipo de empresa.',
            },
            MX: {
                DEFAULT: 'Deben contener el número de CURP, número RFC, nombre del representante legal, nombre de la razón social y dirección.',
                Personafisica: 'Deben contener el número de CURP, número RFC, nombre del representante legal, nombre de la razón social y dirección.',
                Personamoral: 'Deben contener el número RFC, nombre de la razón social, tipo de régimen fiscal y dirección. Debe contener  QR para validar.',
            },
        },
        ecommerce: {
            CO: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'Deve ser anexado na íntegra, conter o tipo societário, nome do representante legal, NIT, razão social, domicílio fiscal. Validade 2019-2020 ou a mais recente para o ano atual.',
            },
            AR: {
                DEFAULT: 'N/A',
                Personahumana: 'N/A',
                Personajuridica: 'O documento deve ser anexado completo e atualizado.',
            },
            UY: {
                DEFAULT: 'N/A',
                Personafisica: 'N/A',
                Personajuridica: 'Deve conter o nome do representante legal, o nome da firma e autenticado por notário.',
            },
            MX: {
                DEFAULT: 'Se deben visualizar datos obligatorios como tipo de societario, nombre del administrador único, nombre de la empresa y firma.',
                Personamoral: 'Se deben visualizar datos obligatorios como tipo de societario, nombre del administrador único, nombre de la empresa y firma.',
            },
        },
        legal: {
            AR: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'O documento deverá ser anexado completo e atualizado.',
            },
            CL: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'Anexe o Certificado de Registro de Santiago completo e legível (que deve ter validade máxima de 6 meses até a data atual) ou você também pode anexar o certificado de status atualizado e completo.',
            },
            EC: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'O documento deve ser legível e deve conter a data, prazo de validade, nome e cargo. A nomeação deve ser enviada com o nome do representante legal, que não tem necessariamente de ser o mesmo que o registado no RUC.',
            },
            MX: {
                DEFAULT: 'Debe estar autenticado en notaría.',
                Personamoral: 'Debe estar autenticado en notaría.',
            },
        },
    },
};
